<template>
	<el-drawer size="40%" :title="innerTitle" :visible.sync="innerVisible" :modal-append-to-body="false" :append-to-body="true"
		:wrapperClosable="false" class="customer-drawer-common">
		<el-form :model="form" :rules="rules" ref="form" label-width="100px">
			<el-form-item label="字段名称: " prop="columnName">
				<el-input v-model="form.columnName" placeholder="请输入字段名称" maxlength="20" show-word-limit></el-input>
			</el-form-item>
			<el-form-item label="字段描述: " prop="columnDescribe">
				<el-input v-model="form.columnDescribe" placeholder="请输入字段描述" maxlength="40" show-word-limit></el-input>
			</el-form-item>
			<el-form-item label="参与查询: " v-show="displayMode == 'input'" prop="listQuery">
				<el-radio-group v-model="form.listQuery">
				    <el-radio label="Y">是</el-radio>
				    <el-radio label="N">否</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="是否加密: " v-show="displayMode == 'input'" prop="encrypt">
				<el-radio-group v-model="form.encrypt">
				    <el-radio label="Y">是</el-radio>
				    <el-radio label="N">否</el-radio>
				</el-radio-group>
			</el-form-item>
		</el-form>
		<div class="table-form" v-if="displayMode == 'droplist' || displayMode == 'radio' || displayMode == 'checkbox'">
			<tableForm @optionsJson="optionsJson" :tableLists="optionsData" :displayMode="displayMode"></tableForm>
		</div>
		<div class="custer-detail-item_item" v-if="displayMode == 'cascade' && columnId">
			<label>选项设置：</label>
			<el-upload
					:before-upload="beforeUpload"
			        :http-request="httpRequestFile"
			        :show-file-list="false"
			        accept=".xlsx, .xls"
			        action="">
			   <div slot="tip" class="el-upload__tip">只能上传execl文件</div>
			   <el-button type="primary" size="mini">上传</el-button>
			</el-upload>
			<a :href="`${cdnUrl}/static/excel/CascadeteMplate.xlsx`" download="模板.xlsx">下载模板</a>
		</div>
		<div class="custer-detail-item_item" style="margin-top: 15px;"  v-if="displayMode == 'cascade'">
			<label>模板选择：</label>
			<el-select v-model="cascadeVal" placeholder="请选择" clearable size="mini" @change="cascadeEvent">
			   <el-option label="省市区" value="district">省市区</el-option>
			</el-select>
		</div>
		<div class="table-form" v-if="displayMode == 'cascade'">
			<cascaderBox :optionsLists="optionsData"  @optionsJson="optionsJson"></cascaderBox> 	
		</div>
		<div class="custer-detail-item_item" v-if="displayMode == 'file'">
			<label>附件：</label>
			<div class="desc">
				<span>上传格式</span>
				<span>文件（可发送文件类型：doc,docx,xls,xlsx,zip,rar,pdf,文件大小20m）</span>
				<span>图片（可发送图片类型：jpg,png,bmp,文件大小20m）</span>
			</div>
		</div>
		<div class="custer-detail-item_btn">
			<el-button @click="resetForm" size="mini">取 消</el-button>
			<el-button type="primary" @click="submitForm" size="mini">保 存</el-button>
		</div>
		 <remote-js :src="`${cdnUrl}/static/common/js/province.js`"></remote-js>
	</el-drawer>
</template>

<script>
	import  { getTableColumnAdd, geTadjustUpdate, geImportOption } from '@/api/manange';
	import tableForm from './tableForm.vue';
	import cascaderBox from './cascaderBox.vue';
	import { calcProvinceCity } from '@/utils/functions.js'
	import { isNumber } from '@/utils/validate.js'
	
	export default {
		props: ['innerTitle','displayMode','columnId'],
		components: {
			tableForm,
			cascaderBox
		},
		data() {
			  var validatePass = (rule, value, callback) => {
				if (value === '') {
				  callback(new Error('请输入字段名称'));
				} else {
				  if (isNumber(value)) {
					callback(new Error('字段名称不能是纯数字'));
				  }
				  callback();
				}
			  };
			 return {
				cdnUrl: process.env.VUE_APP_BASE_CDN,
				innerVisible: false,
				form: {
					columnName: '',
					columnDescribe: '',
					listQuery: 'N',
					encrypt: 'N',
					columnNotNull: 'N',
					optionsJson:''
				},
				rules: {
					columnName: [{ validator: validatePass, trigger: 'blur' }]
				},
				optionsData:[],//数据
				cascadeVal:'',
				defaultOptionsData:[{
					value: '0',
					label: '默认',
					isEdit:false,
					children:[]
				}]
			}
		},
		methods: {
			// 选项设置，级联数据
			optionsJson(val){
				if(val.length == 0) {
					this.form.optionsJson = '';
					return
				}
				if(val[val.length - 1].value == '' || val[val.length - 1].label == '') {
					this.form.optionsJson = '';
				}else {
					this.form.optionsJson = JSON.stringify({
						data:val
					});
				}
			},
			resetForm() {
				 this.innerVisible = false;
			},
			//打开fom弹窗
			openDrawer(row){
				this.innerVisible = true;
				this.$nextTick(() => {
					if(row){
						Object.keys(this.form).map(item => {
							this.form[item] = row[item]
						})
						//选项设置 、级联
						this.optionsData = row.optionsJson ? JSON.parse(row.optionsJson).data : this.displayMode == 'cascade' ? this.defaultOptionsData : [];
					}else {
						this.$refs['form'].resetFields();
						this.optionsData = this.displayMode == 'cascade' ? this.defaultOptionsData : [];
						this.form.optionsJson = this.displayMode == 'cascade' ?  JSON.stringify({
							data:this.defaultOptionsData
						}) : [];
					}
				})
			},
			submitForm(){
				 this.$refs['form'].validate((valid) => {
					 if(valid) {
						 if(this.displayMode == 'droplist' || this.displayMode == 'radio' || this.displayMode == 'checkbox') {
							 if(!this.form.optionsJson){
								 this.$message.error('请填写选项设置');
								 return false
							 }
							 let hash = {},isSame = false;
							 let result = JSON.parse(this.form.optionsJson).data;
							 for(let i in result) {
								 if(hash[result[i].value]){
									 isSame = true
								 }else {
									 isSame = false;
									 hash[result[i].value] = true
								 }
							 }
							 if(isSame){
							  this.$message.error('选项值中不能有相同的code');
							  return false
							 }
						 }
						 // if(this.displayMode == 'cascade' && !this.form.optionsJson) {
							//  this.form.optionsJson = JSON.stringify({
							// 	 data:[{"value":"0","label":"全部分类"}]
							//  })
						 // }
						 let params = {
						 	columnName: this.form.columnName,
						 	displayMode: this.displayMode,
						 	listQuery: this.form.listQuery,
						 	columnDescribe: this.form.columnDescribe,
						 	columnNotNull: this.form.columnNotNull,
							brand:this.$store.getters.userInfo.brandIdentify,
							encrypt:this.form.encrypt,
							optionsJson:this.form.optionsJson
						 }
						 if(this.columnId) {
							 params.columnId = this.columnId;
							 geTadjustUpdate(params).then(res => {
								if(res.errcode == 0){
									this.innerVisible = false;
									this.$emit("updateList")
								}
							 })
						 }else {
							 getTableColumnAdd(params).then(res => {
							 	if(res.errcode == 0){
							 		this.innerVisible = false;
							 		this.$emit("updateList")
							 	}
							 })
						 }
						 
					 }
				 })
			},
			//上传级联数据
			httpRequestFile(file) {
				const self = this
				const formData = new FormData();
				formData.append("tableColumnId", self.columnId);
				formData.append('file', file.file);
				geImportOption(formData).then(res => {
				    if(res.errcode != 0) return;
				    self.$message.success('上传成功');
					this.optionsData = res.data ? JSON.parse(res.data).data : this.defaultOptionsData;
				});
			},
			beforeUpload(file){
				if(file.name.indexOf('xls') != -1) {
					return true
				}
				this.$message.error('只能上传execl文件');
				return false
			},
			cascadeEvent(val){
				this.optionsData = !val ? this.defaultOptionsData : calcProvinceCity(val)
			},
		},
	}
</script>

<style lang="scss" scoped>
	.custer-detail-item_btn {
		display: flex;
		justify-content: flex-end;
		margin: 20px 0;
	}
	.custer-detail-item_item {
		display: flex;
		// align-items: center;
		label {
			display: inline-block;
			width: 100px;
			text-align: right;
			font-size: 12px;
			color: #838A9D;
		}
		a {
			font-size: 12px;
			margin-left: 10px;
			color: #337eff;
			text-decoration: underline;
		}
		.desc {
			display: flex;
			flex-direction: column;
			font-size: 12px;
			color: #FF504D;
			span {
				line-height: 20px;
			}
		}
	}
</style>
